import React from "react";
import ContactMenu from "./ContactMenu";
import "../styles/contact.css";

const Contact = () => {
  return (
    <>
      <p3>
      Stumble across any <k>evil viruses</k> or 
      job opportunities that pertain to my skillset? 
      </p3>
      <p4>
      Feel free to contact me!
      </p4>      
      <ContactMenu />
    </>
  );
};

export default Contact;
